export default __webpack_public_path__ + "static/media/FOTO1.f1835e2c.jpg";